import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { EditorLayoutDefinition, TransportLayout } from '@sdbn/appclient/ac/tmc-legacy/components/transport-layout-editor/transport-layout-editor.model';
import { Station } from 'src/tmc-yard/client/model/station';
import { TransportDetailsLayoutService } from 'src/tmc-yard/components/transport-details/transport-details-layout.service';

@Component({
  selector: 'app-sac-station-tablet',
  templateUrl: './sac-station-tablet.component.html',
  styleUrls: ['./sac-station-tablet.component.scss']
})
export class SACStationTabletComponent implements OnInit, OnDestroy {

  @Input() station: Station;
  
  constructor(
    private transportDetailsLayoutService: TransportDetailsLayoutService
  ) { }

  ngOnInit(): void {

  }

  ngOnDestroy() {

  }

}
